import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var o=React.createContext(void 0),i=e=>{const r=React.useContext(o);if(!r)throw new Error("No QueryClient set, use QueryClientProvider to set one");return r},s=({client:e,children:r})=>(React.useEffect(()=>(e.mount(),()=>{e.unmount();}),[e]),jsx(o.Provider,{value:e,children:r}));

export { o as QueryClientContext, s as QueryClientProvider, i as useQueryClient };
//# sourceMappingURL=contact-channels47.js.map
